import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        event: '=',
        courses: '='
    },
    template: `
    <div class="heading01 type01">
        <h1>{{ 'events.Edit notification rule' | translate }}
            <span ng-if="!vm.event.isActive" class="tag color01">{{ 'user.Inactive' | translate }}</span>
            <span ng-if="vm.event.isActive" class="tag color02">{{ 'user.Active' | translate }}</span>
        </h1>
        <a ui-sref="authorized.events.list()" class="btn discrete">{{ 'general.Back to list' | translate }}</a>
    </div>
    <events-partials-detail
        courses="vm.courses"
        event="vm.event"
        context="vm.context"
    />
</div>

    `
})
export default class {
    constructor () {
        this.context = 'edit';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/events/edit/index.js